import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../Environment/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrderManagementService {
  constructor(private http: HttpClient) {}

  // ---------------------- Get Approve Order List API ---------------------- //

  getApproveOrderList(api: string) {
    const url = `${environment.baseUrl}${api}`;
    return this.http.get(url);
  }

  getBaldiaApproveOrderList(
    api: string,
    cityId: any = null,
    zoneId: any = null,
    fromDate: any = null,
    toDate: any = null
  ) {
    const queryParams: string[] = [];
  
    if (cityId) {
      queryParams.push(`CityId=${cityId}`);
    }
  
    if (zoneId) {
      queryParams.push(`ZoneId=${zoneId}`);
    }
  
    if (fromDate) {
      queryParams.push(`Fromdate=${fromDate}`);
    }
  
    if (toDate) {
      queryParams.push(`Todate=${toDate}`);
    }
  
    const paramString = queryParams.length ? `?${queryParams.join('&')}` : '';
    const url = `${environment.baseUrl}${api}${paramString}`;
    return this.http.get(url);
  }
  

  // --------------------- Post Approve Order Status API --------------------- //

  postApproveOrderStatus(api: string, params: any) {
    const url = `${environment.baseUrl}${api}`;
    return this.http.post(url, params);
  }

  // ---------------------- Get Release Payment List API ---------------------- //

  getReleasePayment(api: string) {
    const url = `${environment.baseUrl}${api}`;
    return this.http.get(url);
  }

  // --------------------- Post Release Payment API --------------------- //

  postReleasePayment(api: string, params: any) {
    const url = `${environment.baseUrl}${api}`;
    return this.http.post(url, params);
  }

  // ---------------------- Get Bank Details API ---------------------- //

  getBankDetails(api: string, orderId: any) {
    const url = `${environment.baseUrl}${api}?OrderId=${orderId}`;
    return this.http.get(url);
  }

  getOrderTimeLine(api: string, orderId: string) {
    const url = `${environment.baseUrl}${api}?OrderId=${orderId}`;
    return this.http.get(url);
  }

  downloadInvoice(orderId: string, api: string) {
    const url = `${environment.baseUrl}${api}?OrderId=${orderId}`;
    return this.http.get(url, { observe: 'response', responseType: 'blob' });
  }

  getDumpyardList(api: string, orderId?: any) {
    let params: string = '';

    if (orderId) {
      params += `?OrderId=${orderId}`;
    }
    const url = `${environment.baseUrl}${api}${params}`;
    return this.http.get(url);
  }

  postBaldiaApprove(api: string, params: any, formData: FormData) {
    const queryParams: any = {
      OrderId: params.OrderId,
      RequestorUserId: params.RequestorUserId,
      BaldiaApproval: params.BaldiaApproval,
    };

    if (params.DumpyardUserId) {
      queryParams.DumpyardUserId = params.DumpyardUserId;
    }

    if (params.DumpyardDistance) {
      queryParams.DumpyardDistance = params.DumpyardDistance;
    }

    const queryString = new URLSearchParams(queryParams).toString();
    const url = `${environment.baseUrl}${api}?${queryString}`;

    return this.http.post(url, formData);
  }

  // ---------------------- Get Baldia Download API ---------------------- //

  getBaldiaDoc(api: string, OrderId: any) {
    const url = `${environment.baseUrl}${api}?OrderId=${OrderId}`;
    return this.http.get(url, { observe: 'response', responseType: 'blob' });
  }

  // ---------------------- Get View Baldia Download API ---------------------- //

  getEocDoc(api: string, orderId: string): Observable<any> {
    return this.http.get(`${environment.baseUrl}${api}?OrderId=${orderId}`);
  }
}
